import { useState } from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { DependentMenu } from './components/dependent-menu';
import { EmptyList } from './components/empty-list';
import { ManageDependentDialog } from './components/manage-dependent-dialog';
import { fontWeights } from '@/@mui/tokens/font-weights';
import { ContentBox } from '@/components/shared/content-box';
import { PageContainer } from '@/components/shared/page-container';
import { PageHeader } from '@/components/shared/page-header';
import { PageSkeleton } from '@/components/shared/page-skeleton';
import { useDependentsIndex } from '@/data/collaborators/dependents';
import { kinshipDegreeLabels } from '@/data/collaborators/dependents/interfaces';
import { useUser } from '@/data/user';
import { useSetTitle } from '@/hooks/use-set-title';

const title = 'Meus dependentes';

export const Dependents = () => {
  useSetTitle(title);
  const [showAddDependentDialog, setShowAddDependentDialog] = useState(false);
  const { user } = useUser();
  const { dependents, isLoading } = useDependentsIndex(user?.colaborador?.id);

  if (isLoading) return <PageSkeleton />;

  return (
    <PageContainer>
      <PageHeader
        title={title}
        description="Adicione e gerencie dependentes para compartilhar seus benefícios!"
        buttonText="Adicionar dependente"
        buttonOnClick={() => setShowAddDependentDialog(true)}
        divider
      />
      <Stack gap={2}>
        {dependents?.length === 0 && <EmptyList />}
        {dependents?.map((dependent) => {
          const lastAccess = dependent?.user?.ultimo_acesso;
          return (
            <ContentBox key={dependent.id}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                flexWrap="wrap"
                gap={2}
              >
                <Box>
                  <Typography fontWeight={fontWeights.fontWeightBold}>
                    {dependent?.user?.nome}
                  </Typography>
                  <Typography mt={1}>
                    {kinshipDegreeLabels[dependent?.kinship_degree]}
                  </Typography>
                </Box>
                <Stack direction="row" alignItems="center" gap={2}>
                  <Box width="150px">
                    <Typography fontWeight={fontWeights.fontWeightBold}>
                      Status
                    </Typography>
                    <Chip
                      sx={{ mt: 1 }}
                      label={lastAccess ? 'Ativo' : 'Convite enviado'}
                      color={lastAccess ? 'success' : 'warning'}
                    />
                  </Box>
                  <DependentMenu dependent={dependent} />
                </Stack>
              </Stack>
            </ContentBox>
          );
        })}
      </Stack>
      {showAddDependentDialog && (
        <ManageDependentDialog
          onClose={() => setShowAddDependentDialog(false)}
        />
      )}
    </PageContainer>
  );
};
